import Ledgers from './ledgers';
import DayBook from './DayBook';
import GstReportTable from '../../../../components/Table/GstReportTable';
import GSTR3BTable11 from '../../../../components/Table/GSTR3BTable11';
import GroupingColumnTable from '../../../../components/Table/GroupingColumnTable';
import GSTR3BTable3 from '../../../../components/Table/GSTR3BTable3';
import GSTR3BTable4 from '../../../../components/Table/GSTR3BTable4';
import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { API, graphqlOperation } from 'aws-amplify';
import { listAccountTransactionDetailsv3 } from '../../../../graphql';
import { defaultRowsPerPage } from '../../../../utils/common';

const AllTables = ({
  data,
  dayBookData,
  dataCount,
  showSearch,
  setTableData,
  setdataCount,
  selectedTab,
  ledgersData,
  includeOpeningBalance,
  page,
  setPage,
  rowsPerPage,
  listOfStates,
  selectedAccount,
  setRowsPerPage,
  dayBookList,
  handleChangePage,
  gstData,
}) => {
  const dashboardData = useSelector((state) => state?.DashboardDataReducer);

  const { startTimeStamp, endTimeStamp } = dashboardData?.report;

  const [ledgerPage, setLedgerPage] = useState(0);
  const [ledgerRowsPerPage, setLedgerRowsPerPage] = useState(defaultRowsPerPage);
  const handleLedgerChangePage = async (event, newPage) => {
    if (newPage > ledgerPage) {
      if (data.data.length !== data.count) {
        if (data.data.length < ledgerRowsPerPage * (newPage + 1)) {
          let response = await API.graphql(
            graphqlOperation(listAccountTransactionDetailsv3, {
              accountid: data.data[0]?.accountid,
              startdate: startTimeStamp,
              openingbalance: includeOpeningBalance === true ? 1 : 0,
              enddate: endTimeStamp,
              rowfrom: data.data.length - 1,
              limitno: Math.abs(ledgerRowsPerPage * (newPage + 1)),
            })
          );
          const remainingAccounts = response.data.listAccountTransactionDetailsv3.slice(1);
          if (response.data.listAccountTransactionDetailsv3.length > 0) {
            setTableData((prevItems) =>
              prevItems.map((item) => {
                return item.data[0].accountid === data.data[0]?.accountid ? { ...item, data: [...item.data, ...remainingAccounts] } : item;
              })
            );
          }
        }
      }
    }
    setLedgerPage(newPage);
  };

  // // Handle Rows Per Page Change
  const handleLedgerChangeRowsPerPage = async (event) => {
    setLedgerRowsPerPage(parseInt(event.target.value, 10));
    setLedgerPage(0); // Reset to first page on change

    let response = await API.graphql(
      graphqlOperation(listAccountTransactionDetailsv3, {
        accountid: data.data[0]?.accountid,
        startdate: startTimeStamp,
        openingbalance: includeOpeningBalance === true ? 1 : 0,
        enddate: endTimeStamp,
        rowfrom: 0,
        limitno: event.target.value,
      })
    );
    if (response.data.listAccountTransactionDetailsv3.length > 0) {
      setTableData((prevItems) =>
        prevItems.map((item) => {
          return item.data[0].accountid === data.data[0]?.accountid
            ? {
                ...item,
                data: [...response.data.listAccountTransactionDetailsv3],
              }
            : item;
        })
      );
    }
  };
  return (
    <>
      {data && data?.data?.length >= 0 && (
        <Ledgers
          key={data.accountid}
          accountid={data.accountid}
          data={data.data}
          setTableData={setTableData}
          includeOpeningBalance={includeOpeningBalance}
          selectedTab={selectedTab}
          count={data.count}
          ledgersData={ledgersData}
          setdataCount={setdataCount}
          rowsPerPage={rowsPerPage}
          totalDebit={data.debit}
          totalCredit={data.credit}
          totalbalance={data.total}
          handleChangePage={handleLedgerChangePage}
          handleChangeRowsPerPage={handleLedgerChangeRowsPerPage}
        />
      )}
      {dayBookData && dayBookData.length >= 0 && selectedTab === 4 && (
        <DayBook
          key={dayBookData?.transactionid}
          dayBookData={dayBookData}
          dataCount={dataCount}
          setdataCount={setdataCount}
          page={page}
          showSearch={showSearch}
          selectedTab={selectedTab}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          dayBookList={dayBookList}
          setTableData={setTableData}
          handleChangePage={handleChangePage}
        />
      )}
      {(selectedAccount?.[0]?.accountsid == '001' || selectedAccount?.[0]?.accountsid == '002') && gstData && gstData.length > 0 && (
        <GstReportTable tableData={gstData} gstTable={selectedAccount[0].accountname} listOfStates={listOfStates} />
      )}

      {selectedAccount?.[0]?.accountsid == '003' && gstData && gstData.length > 0 && (
        <>
          <GSTR3BTable11 data={gstData} />
          <GroupingColumnTable data={gstData} />
          <GSTR3BTable3 data={gstData} />
          <GSTR3BTable4 data={gstData} />
        </>
      )}
    </>
  );
};

export default AllTables;
